export enum DataHooks {
  WeekPicker = 'week-picker',
  SrOnlyAnnouncement = 'week-picker-sr-only-announcement',
}
